// Module
var code = `<template class="ag-date-editor">
  <require from="./agDateEditor.scss"></require>
  <input ref="input" inputmask="mask:datetime; options.bind: { inputFormat: 'dd.mm.yyyy' }; is-value-masked: true; value.bind: value">
</template>
`;
// Exports
export default code;